import React from 'react'
import styles from './index.module.scss'

/**
 * Generic Item Header Component
 *
 * @param {React.ReactNode} title - Title content
 * @param {React.ReactNode} badges - Badges or additional header content
 * @param {string} className - Additional CSS classes
 */
const Header = ({ title, badges, className = '' }) => {
  return (
    <div className={`${styles.itemHeader} ${className}`}>
      <div className={styles.itemTitle}>
        {title}
      </div>
      {badges && (
        <div className={styles.itemBadges}>
          {badges}
        </div>
      )}
    </div>
  )
}

/**
 * Generic Item Description Component
 *
 * @param {React.ReactNode} children - Description content
 * @param {string} className - Additional CSS classes
 */
const Description = ({ children, className = '' }) => {
  return (
    <div className={`${styles.itemDescription} ${className}`}>
      {children}
    </div>
  )
}

/**
 * Generic Item Layout Component
 *
 * @param {React.ReactNode} children - Main content of the item
 * @param {Function} onClick - Click handler
 * @param {boolean} isSelected - Whether the item is selected
 * @param {string} className - Additional CSS classes
 */
const Item = ({
  children,
  onClick,
  isSelected = false,
  className = '',
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <div
      className={`${styles.item} ${isSelected ? styles.selected : ''} ${className}`}
      onClick={handleClick}
    >
      <div className={styles.itemContent}>
        {children}
      </div>
    </div>
  )
}

// Attach subcomponents
Item.Header = Header
Item.Description = Description

export default Item
